import ExtendedMedicationInfo from '../ExtendedMedicationInfo'
import { getSubstitutions } from 'util/apiFieldFormatters'
import { useState } from 'react'
import CancelMedicationModal from 'components/ModalsContainer/v1Modals/CancelMedication'

type MedicationContentProps = {
  // TODO - improve type
  visit: any
  prescriptionId: string
  name?: string
  quantity?: number
  refills: number
  daysSupply?: number
  directions: string
  unit: string
  notes?: string
  substitutions: string
  writtenDate: string
  isChangeButtonShown?: boolean
  removalForbidden?: boolean
  cancellationReason?: string
}

const MedicationContent = ({
  visit,
  prescriptionId,
  name,
  directions,
  unit,
  quantity,
  refills,
  daysSupply,
  notes,
  substitutions,
  writtenDate,
  isChangeButtonShown,
  removalForbidden,
  cancellationReason,
}: MedicationContentProps) => {
  const [isCancelDialogVisible, setIsCancelDialogVisible] = useState(false)

  const cancelMedication = async (values) => {
    setIsCancelDialogVisible(false)
    await visit.rxs.removeMedication(prescriptionId, values?.cancellationReason)
  }

  return (
    <div className="flex justify-between content-start mt-4 mb-8">
      <div>
        <ExtendedMedicationInfo
          medication={name}
          directions={directions}
          notes={notes}
          unit={unit}
          substitutions={getSubstitutions(substitutions)}
          writtenDate={writtenDate}
          quantity={quantity}
          refills={refills}
          daysSupply={daysSupply}
          cancellationReason={cancellationReason}
        />
      </div>
      {isChangeButtonShown && !removalForbidden && (
        <button className="btn btn-fuchsia-outlined" onClick={() => setIsCancelDialogVisible(true)} type="button">
          Cancel
        </button>
      )}
      {!!isCancelDialogVisible && (
        <CancelMedicationModal cancelMedication={cancelMedication} onClose={() => setIsCancelDialogVisible(false)} />
      )}
    </div>
  )
}

export default MedicationContent
